import React, { useEffect, useState } from "react";
import style from "./AdminAnalytics.module.scss";
import { AiOutlineClose, AiOutlineUserAdd } from "react-icons/ai";
import AdminAnalyticsFilter from "./AdminAnalyticsFilter";
import { useSelector } from "react-redux";
import { GetAdminAnalytics } from "../../../../apiServices";
import { dateFormateDD, MyModal } from "../../../../utility";
import ModalContainer from "../../../../components/modal_popup";
import AdminTableView from "./AdminTableView";
import { useDispatch } from "react-redux";
import { AdminAnalyticsActions } from "../../../../redux-store/store";
import AdminTableFilter from "./AdminTableFilter";
import AdminAnalyticsCandidateTableView from "./AdminAnalyticsCandidateTableView";
import Interview_Scheduled_Icon from "../../../../assets/images/Interview Scheduled.svg";
import Interview_attended_Icon from "../../../../assets/images/Attended.svg";
import Interview_selected_Icon from "../../../../assets/images/Selected.svg";
import Interview_joined_Icon from "../../../../assets/images/Joined.svg";
import Interview_intreviews_Icon from "../../../../assets/images/Attending.svg";
import Interview_leadRegistered_Icon from "../../../../assets/images/Lead Registered_Color.png";
import Interview_leadNotReg_Icon from "../../../../assets/images/Lead Not Registered_Color.png";
import Registered_icon from "../../../../assets/images/Registered.svg";
import Interview_totalLead_Icon from "../../../../assets/images/Total Lead.svg";
import Interview_left_company from "../../../../assets/images/Left.svg";
import { BiWindowOpen } from "react-icons/bi";
// import Interview_Scheduled_Icon from "../../../../assets/images/Interview Scheduled.svg";

const AdminAnalytics = () => {
  const adminAnalyticsFilter = useSelector(
    (state) => state.AdminAnalytics.analyticsFilter
  );
  const adminAnalyticsFilterType = useSelector(
    (state) => state.AdminAnalytics.typeAnalyticsFilter.type
  );
  const adminAnalyticsFilterTotalRecords = useSelector(
    (state) => state.AdminAnalytics.typeAnalyticsFilter.totalRecords
  );
  const dispatch = useDispatch();
  const [openType, setOpenType] = useState(false);
  const [candidateopenType, setCandidateOpenType] = useState(false);
  const [dataCount, setDataCount] = useState({
    interviewScheduledByAdmin: "",
    interviews: "",
    interviewAttended: "",
    selected: "",
    joined: "",
    leftCompany: "",
    registeredCount: "",
    leadNotRegistredCount: "",
    leadRegisteredCount: "",
    totalLead: "",
  });
  useEffect(() => {}, [adminAnalyticsFilter]);
  useEffect(() => {
    GetAdminAnalytics(adminAnalyticsFilter).then((data) => {
      console.log(data);
      setDataCount({
        interviewScheduledByAdmin: data.results.interviewScheduledByAdmin,
        interviews: data.results.interviews,
        interviewAttended: data.results.interviewAttended,
        selected: data.results.Selected,
        joined: data.results.joined,
        leftCompany: data.results.leftCompany,
        registeredCount: data.results.registeredCount,
        leadNotRegistredCount: data.results.leadNotRegistredCount,
        leadRegisteredCount: data.results.leadRegisteredCount,
        totalLead: data.results.totalLead,
      });
    });
  }, [adminAnalyticsFilter]);

  const handleClickOpenAnalytics = (type) => {
    console.log(type, "type");

    if (type) {
      dispatch(AdminAnalyticsActions.settypeAnalyticsType(type));
      dispatch(
        AdminAnalyticsActions.settypeAnalyticsStartDate(
          adminAnalyticsFilter.startDate
        )
      );
      dispatch(
        AdminAnalyticsActions.settypeAnalyticsendDate(
          adminAnalyticsFilter.endDate
        )
      );
      dispatch(
        AdminAnalyticsActions.settypeAnalyticsAdmin(
          adminAnalyticsFilter.adminId
        )
      );

      setOpenType(true);
    }
  };
  const handleCandidateClickOpenAnalytics = (type) => {
    // console.log(type, "type");

    if (type) {
      dispatch(AdminAnalyticsActions.settypeAnalyticsType(type));
      dispatch(
        AdminAnalyticsActions.settypeAnalyticsStartDate(
          adminAnalyticsFilter.startDate
        )
      );
      dispatch(
        AdminAnalyticsActions.settypeAnalyticsendDate(
          adminAnalyticsFilter.endDate
        )
      );

      dispatch(
        AdminAnalyticsActions.settypeAnalyticsAdmin(
          adminAnalyticsFilter.adminId
        )
      );
      setCandidateOpenType(true);
    }
  };

  const handleOnclose = () => {
    setCandidateOpenType(false);
    dispatch(AdminAnalyticsActions.settypeAnalyticsPage(0));
  };
  const handleOnCloseInterview = () => {
    setOpenType(false);
    dispatch(AdminAnalyticsActions.settypeAnalyticsPage(0));
    dispatch(AdminAnalyticsActions.settypeAnalyticsCompanyName(""));
  };
  return (
    <>
      <div className="container-fluid">
        <div className="d-flex align-items-center justify-content-between mb-2">
          {" "}
          <div>
            <b>{dateFormateDD(adminAnalyticsFilter.startDate)} </b> to{" "}
            <b>{dateFormateDD(adminAnalyticsFilter.endDate)} </b>
          </div>
          <AdminAnalyticsFilter />
        </div>
        <div className="row mt-3">
          <div className="col-sm-3">
            <div className={`${style.cardAnalytics1}`}>
              <div className="d-flex justify-content-between">
                <b>Total Lead</b>
                {/* <span>
                  {" "}
                  <BiWindowOpen
                    className="text-primary"
                    cursor={"pointer"}
                    title="View Details"
                    style={{ fontSize: "20px" }}
                    onClick={() => {
                      handleCandidateClickOpenAnalytics("totalLead");
                    }}
                  />
                </span> */}
              </div>

              <div className="mt- 3 mb-3 d-flex justify-content-center align-items-center gap-3">
                <div className="mt-2 d-flex align-items-center gap-3">
                  <div className={`${style.analyticsIcon}`}>
                    <img
                      src={Interview_totalLead_Icon}
                      alt="Interview_totalLead_Icon"
                      width={50}
                    />
                  </div>
                  <div className={`${style.analyticsCount}`}>
                    {dataCount.totalLead}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-3">
            <div
              className={`${style.cardAnalytics}`}
              onClick={() => {
                handleCandidateClickOpenAnalytics("leadRegisteredCount");
              }}
            >
              <div className="d-flex justify-content-between">
                <b>Lead Registered</b>
                {/* <span>
                  {" "}
                  <BiWindowOpen
                    className="text-primary"
                    cursor={"pointer"}
                    title="View Details"
                    style={{ fontSize: "20px" }}
                    onClick={() => {
                      handleCandidateClickOpenAnalytics("leadRegisteredCount");
                    }}
                  />
                </span> */}
              </div>

              <div className="mt- 3 mb-3 d-flex justify-content-center align-items-center gap-3">
                <div className="mt-2 d-flex align-items-center gap-3">
                  <div className={`${style.analyticsIcon}`}>
                    <img
                      src={Interview_leadRegistered_Icon}
                      alt="Interview_leadRegistered_Icon"
                      width={50}
                    />
                  </div>
                  <div className={`${style.analyticsCount}`}>
                    {dataCount.leadRegisteredCount}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-3">
            <div
              className={`${style.cardAnalytics}`}
              onClick={() => {
                handleCandidateClickOpenAnalytics("leadNotRegistredCount");
              }}
            >
              <div className="d-flex justify-content-between">
                <b>Lead Not Registered</b>
                {/* <span>
                  {" "}
                  <BiWindowOpen
                    className="text-primary"
                    cursor={"pointer"}
                    title="View Details"
                    style={{ fontSize: "20px" }}
                  />
                </span> */}
              </div>
              <div className="mt- 3 mb-3 d-flex justify-content-center align-items-center gap-3">
                <div className="mt-2 d-flex align-items-center gap-3">
                  <div className={`${style.analyticsIcon}`}>
                    <img
                      src={Interview_leadNotReg_Icon}
                      alt="Interview_leadNotReg_Icon"
                      width={50}
                    />
                  </div>
                  <div className={`${style.analyticsCount}`}>
                    {dataCount.leadNotRegistredCount}
                  </div>
                </div>
              </div>
            </div>
          </div>{" "}
          <div className="col-sm-3">
            <div
              className={`${style.cardAnalytics}`}
              onClick={() => {
                handleCandidateClickOpenAnalytics("registeredCount");
              }}
            >
              <div className="d-flex justify-content-between">
                <b>Registered (Over All)</b>
                {/* <span>
                  {" "}
                  <BiWindowOpen
                    className="text-primary"
                    cursor={"pointer"}
                    title="View Details"
                    style={{ fontSize: "20px" }}
                  />
                </span> */}
              </div>

              <div className="mt- 3 mb-3 d-flex justify-content-center align-items-center gap-3">
                <div className="mt-2 d-flex align-items-center gap-3">
                  <div className={`${style.analyticsIcon}`}>
                    <img
                      src={Registered_icon}
                      alt="Registered_icon"
                      width={50}
                    />
                  </div>{" "}
                  <div className={`${style.analyticsCount}`}>
                    {dataCount.registeredCount}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-5">
          {" "}
          <div className="row">
            {" "}
            <div className="col-sm-2">
              <div
                className={`${style.cardAnalytics}`}
                onClick={() => {
                  handleClickOpenAnalytics("interviewScheduledByAdmin");
                }}
              >
                <div className="d-flex justify-content-between">
                  <b>Interview Scheduled</b>
                  {/* <span>
                    {" "}
                    <BiWindowOpen
                      className="text-primary"
                      cursor={"pointer"}
                      title="View Details"
                      style={{ fontSize: "20px" }}
                     
                    />
                  </span> */}
                </div>
                <div className="mt-3 mb-3 d-flex flex-column justify-content-center align-items-center gap-2">
                  <div className={`mt-3 ${style.analyticsIcon}`}>
                    <img
                      src={Interview_Scheduled_Icon}
                      alt="Interview_Scheduled_Icon"
                      width={50}
                    />
                  </div>
                  <div className={`${style.analyticsCount}`}>
                    {dataCount.interviewScheduledByAdmin}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div
                className={`${style.cardAnalytics}`}
                onClick={() => {
                  handleClickOpenAnalytics("interviews");
                }}
              >
                <div className="d-flex justify-content-between">
                  <b>Interviews</b>
                  {/* <span>
                    {" "}
                    <BiWindowOpen
                      className="text-primary"
                      cursor={"pointer"}
                      title="View Details"
                      style={{ fontSize: "20px" }}
                    />
                  </span> */}
                </div>
                <div className="mt-3 mb-3 d-flex flex-column justify-content-center align-items-center gap-2">
                  <div className={`mt-3 ${style.analyticsIcon}`}>
                    <img
                      src={Interview_intreviews_Icon}
                      alt="Interview_intreviews_Icon"
                      width={50}
                    />
                  </div>
                  <div className={`${style.analyticsCount}`}>
                    {dataCount.interviews}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div
                className={`${style.cardAnalytics}`}
                onClick={() => {
                  handleClickOpenAnalytics("interviewAttended");
                }}
              >
                <div className="d-flex justify-content-between">
                  <b>Interview Attended</b>
                  {/* <span>
                    {" "}
                    <BiWindowOpen
                      className="text-primary"
                      cursor={"pointer"}
                      title="View Details"
                      style={{ fontSize: "20px" }}
                      
                    />
                  </span> */}
                </div>{" "}
                <div className="mt-3 mb-3 d-flex flex-column justify-content-center align-items-center gap-2">
                  <div className={`mt-3 ${style.analyticsIcon}`}>
                    <img
                      src={Interview_attended_Icon}
                      alt="Interview_attended_Icon"
                      width={40}
                    />
                  </div>
                  <div className={`${style.analyticsCount}`}>
                    {dataCount.interviewAttended}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div
                className={`${style.cardAnalytics}`}
                onClick={() => {
                  handleClickOpenAnalytics("selected");
                }}
              >
                <div className="d-flex justify-content-between">
                  <b>Interview Selected</b>
                  <span>
                    {" "}
                    {/* <BiWindowOpen
                      className="text-primary"
                      cursor={"pointer"}
                      title="View Details"
                      style={{ fontSize: "20px" }}
                    /> */}
                  </span>
                </div>{" "}
                <div className="mt-3 mb-3 d-flex flex-column justify-content-center align-items-center gap-2">
                  <div className={`mt-3 ${style.analyticsIcon}`}>
                    <img
                      src={Interview_selected_Icon}
                      alt="Interview_selected_Icon"
                      width={40}
                    />
                  </div>
                  <div className={`${style.analyticsCount}`}>
                    {dataCount.selected}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div
                className={`${style.cardAnalytics}`}
                onClick={() => {
                  handleClickOpenAnalytics("joined");
                }}
              >
                <div className="d-flex justify-content-between">
                  <b>Joined Company</b>
                  {/* <span>
                    {" "}
                    <BiWindowOpen
                      className="text-primary"
                      cursor={"pointer"}
                      title="View Details"
                      style={{ fontSize: "20px" }}
                    />
                  </span> */}
                </div>{" "}
                <div className="mt-3 mb-3 d-flex flex-column justify-content-center align-items-center gap-2">
                  <div className={`mt-3 ${style.analyticsIcon}`}>
                    <img
                      src={Interview_joined_Icon}
                      alt="Interview_joined_Icon"
                      width={50}
                    />
                  </div>
                  <div className={`${style.analyticsCount}`}>
                    {dataCount.joined}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div
                className={`${style.cardAnalytics}`}
                onClick={() => {
                  handleClickOpenAnalytics("leftCompany");
                }}
              >
                <div className="d-flex justify-content-between">
                  <b>Left Company</b>
                  {/* <span>
                    {" "}
                    <BiWindowOpen
                      className="text-primary"
                      cursor={"pointer"}
                      title="View Details"
                      style={{ fontSize: "20px" }}
                    />
                  </span> */}
                </div>{" "}
                <div className="mt-3 mb-2 d-flex flex-column justify-content-center align-items-center gap-2">
                  <div className={`mt-3 ${style.analyticsIcon}`}>
                    <img
                      src={Interview_left_company}
                      alt="Interview_left_company"
                      width={40}
                    />
                  </div>
                  <div className={`${style.analyticsCount}`}>
                    {dataCount.leftCompany}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {openType && (
          <>
            <MyModal>
              <ModalContainer
                childComponent={
                  <>
                    <AdminTableView onclose={handleOnCloseInterview} />
                  </>
                }
              />
            </MyModal>
          </>
        )}
        {candidateopenType && (
          <>
            <MyModal>
              <ModalContainer
                childComponent={
                  <>
                    <AdminAnalyticsCandidateTableView onclose={handleOnclose} />
                  </>
                }
              />
            </MyModal>
          </>
        )}
      </div>
    </>
  );
};

export default AdminAnalytics;
